import { NgModule } from '@angular/core';
import type { Route } from '@angular/router';
import { RouterModule } from '@angular/router';

import { WalkthroughType } from '@core/walkthrough-legacy';
import { WalkthroughEmptyComponent } from '@core/walkthrough-util';

import { activateWalkthrough } from './walkthrough-route.helpers';
import { BrowseJobWalkthroughService } from '../services/walkthrough-browse-job.service';
import { CollaborativeHiringWalkthroughService } from '../services/walkthrough-collaborative-hiring.service';
import { CreateJobWalkthroughService } from '../services/walkthrough-create-job.service';
import { DisqualifyReasonsWalkthroughService } from '../services/walkthrough-disqualify-reasons.service';
import { EmailTemplatesWalkthroughService } from '../services/walkthrough-email-templates.service';
import { EvaluateCandidateWalkthroughService } from '../services/walkthrough-evaluate-candidate.service';
import { JobDescriptionWalkthroughService } from '../services/walkthrough-job-description.service';
import { MarketplaceToolboxWalkthroughService } from '../services/walkthrough-marketplace-toolbox.service';
import { MarketplaceWalkthroughService } from '../services/walkthrough-marketplace.service';
import { NavigationWalkthroughService } from '../services/walkthrough-navigation.service';
import { PipelineOverviewWalkthroughService } from '../services/walkthrough-pipeline-overview.service';
import { PipelineWalkthroughService } from '../services/walkthrough-pipline.service';
import { ProceedDisqualifyWalkthroughService } from '../services/walkthrough-proceed-disqualify.service';
import { PublishJobWalkthroughService } from '../services/walkthrough-publish-job.service';
import { ScheduleInterviewsWalkthroughService } from '../services/walkthrough-schedule-interviews.service';

/* id used in backed for dynamic data
 *
 *   -3 : candidate
 *   -1 (slug: draft) : offer (not published)
 *   -2 (published) : offer (published)
 *
 *
 * */

export const ROUTES: Route[] = [
  {
    path: WalkthroughType.Pipelines,
    canActivate: [activateWalkthrough(PipelineWalkthroughService, '/settings/pipeline_templates')],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.DisqualifyReasons,
    canActivate: [
      activateWalkthrough(DisqualifyReasonsWalkthroughService, '/settings/disqualify_reasons'),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.Jobs,
    canActivate: [activateWalkthrough(CreateJobWalkthroughService, '/offers')],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.PublishJobs,
    canActivate: [
      activateWalkthrough(PublishJobWalkthroughService, '/offers(job-editor:draft/job_details)'),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.PipelineOverview,
    canActivate: [
      activateWalkthrough(PipelineOverviewWalkthroughService, '/offers/published/pipeline'),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.EvaluateCandidate,
    canActivate: [
      activateWalkthrough(
        EvaluateCandidateWalkthroughService,
        '/candidates?candidate=-3&tab=interviews',
      ),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.ScheduleInterview,
    canActivate: [
      activateWalkthrough(
        ScheduleInterviewsWalkthroughService,
        '/candidates?candidate=-3&tab=interviews',
      ),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.CollaborativeHiring,
    canActivate: [
      activateWalkthrough(
        CollaborativeHiringWalkthroughService,
        '/candidates?candidate=-3&tab=interviews',
      ),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.ProceedDisqualify,
    canActivate: [
      activateWalkthrough(
        ProceedDisqualifyWalkthroughService,
        '/candidates?candidate=-3&tab=interviews',
      ),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.EmailTemplates,
    canActivate: [
      activateWalkthrough(EmailTemplatesWalkthroughService, '/settings/emails/general/-1'),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.BrowseJobs,
    canActivate: [activateWalkthrough(BrowseJobWalkthroughService, '/offers/views/jobs:all')],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.Marketplace,
    canActivate: [activateWalkthrough(MarketplaceWalkthroughService, '/marketplace/all')],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.MarketplaceToolbox,
    canActivate: [activateWalkthrough(MarketplaceToolboxWalkthroughService, '/marketplace/all')],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.JobDescription,
    canActivate: [
      activateWalkthrough(
        JobDescriptionWalkthroughService,
        '/offers(job-editor:draft/job_details)',
      ),
    ],
    component: WalkthroughEmptyComponent,
  },
  {
    path: WalkthroughType.NavigationTour,
    canActivate: [activateWalkthrough(NavigationWalkthroughService, '/dashboard/new_walkthrough')],
    component: WalkthroughEmptyComponent,
  },
];

@NgModule({ imports: [RouterModule.forChild(ROUTES)] })
export class WalkthroughRoutingModule {}
